import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifPph29Service = new CrudCustom('/tarif-pph-29s');
export default TarifPph29Service;
